<div *ngIf="isDisplay">
  <div class="error-msg">
    {{ message }}
  </div>
</div>
